import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    referrals: 
       { referrerName: null,
         selectedResponse: "",
       }
};

export const referralSlice = createSlice({
    name: "referral",
    initialState,
    reducers: {
        updateReferralInfo: (state, action) => {
            state.referrals.referrerName = action.payload;
        },
        updateReferralResponse: (state, action) => {
            state.referrals.selectedResponse = action.payload;
        },
    },
});

export const { updateReferralInfo, updateReferralResponse } = referralSlice.actions;
export const referralReducer = referralSlice.reducer;